module.exports = __webpack_public_path__ + "img/logo-alt.75efe1b1.svg";